var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.error)?_c('div',{staticClass:"errors alert alert-danger"},[_c('div',{staticClass:"editorError"},[_c('label',{attrs:{"for":_vm.isEmailError ? 'contactEmail' : ''}},[_vm._v(_vm._s(_vm.error))])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }